import {
  FSM_ENDED_MODAL_ROUTES,
  FSM_FREE_PLAN_ROUTES,
  FSM_LITE_ENDED_MODAL_ROUTES,
  FSM_UPGRADE_NEEDED_ROUTES
} from './constants';
import useFSMPlanInfo from 'containers/integrations/fsm-integration/hooks/useFSMPlanInfo';

export const shouldShowFSMModal = (pathname: string) => {
  const {
    isNoPlan,
    isFSMLitePlan,
    isFSMPlusPlan,
    isSystemDowngraded,
    hasDowngradedAfterTrial,
    isInFSMGracePeriod,
    migratedTeamWithJobs
  } = useFSMPlanInfo();

  const isFSMSubscriptionNeeded = FSM_FREE_PLAN_ROUTES.some(route => pathname.includes(route));

  const isUpgradeNeeded = FSM_UPGRADE_NEEDED_ROUTES.some(route => pathname.includes(route));

  const showFSMEndedModal = FSM_ENDED_MODAL_ROUTES.some(route => pathname.includes(route));

  const showFSMLiteEndedModal = FSM_LITE_ENDED_MODAL_ROUTES.some(route => pathname.includes(route));

  if (isInFSMGracePeriod && isFSMSubscriptionNeeded) {
    return false;
  }
  if (migratedTeamWithJobs && !isInFSMGracePeriod && isFSMSubscriptionNeeded && !showFSMLiteEndedModal) {
    return false;
  }

  if (migratedTeamWithJobs && !isInFSMGracePeriod && showFSMLiteEndedModal && isNoPlan) {
    return true;
  }

  if (isNoPlan) {
    return isFSMSubscriptionNeeded || isUpgradeNeeded;
  }

  if (isFSMSubscriptionNeeded && (isSystemDowngraded || hasDowngradedAfterTrial)) {
    return showFSMLiteEndedModal;
  }
  if (isUpgradeNeeded && isFSMPlusPlan && (isSystemDowngraded || hasDowngradedAfterTrial)) {
    return showFSMEndedModal;
  }

  if (isFSMLitePlan) {
    return isUpgradeNeeded;
  }

  return false;
};

export const isFSMLiteRoute = (pathname: string) => {
  return FSM_LITE_ENDED_MODAL_ROUTES.some(route => pathname.includes(route));
};

export const isFSMPlusRoute = (pathname: string) => {
  return FSM_UPGRADE_NEEDED_ROUTES.some(route => pathname.includes(route));
};
